export const API_URL = 'https://ddinvipi-2.diamondsdirect.com/v1';
export const DIAMOND_API = 'https://dapi.diamondsdirect.com';
export const FRONTEND_URL = 'https://showcase.diamondsdirect.com';
export const SHARE_URL = 'https://v.diamondsdirect.com';

export const HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};
export const FILE_HEADERS = {
	'Accept': 'application/json'
};

export const IS_STAGING = false;